export const ComponentDefaults = {
    className: '',
    style: {},
};
